import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-restart-chat',
  standalone: false,
  templateUrl: './restart-chat.component.html',
  styleUrl: './restart-chat.component.scss'
})
export class RestartChatComponent {

  constructor(private dialogRef: MatDialogRef<RestartChatComponent>) {}

  close(result: boolean) {
    this.dialogRef.close(result);
  }

}
